import type { OpsItem } from '@/domain/opsWorklist';

/**
 * Which worklist kinds have an Ops decision behind them, so their row shows an
 * Action button that opens the OpsWorkModal. The remaining monitoring lists
 * (upcoming top-ups, unanswered messages) are surfaced for awareness and have no
 * modal action of their own (vault Diagram 09). No-rebook opens the modal to see
 * the piece progress, the checkout reason, and mark the flag complete.
 * W5: a pay-by extension is an Ops decision; an unclosed link is Ops's to close
 * only when Ops owns it (Messenger-sent) — Agent / Sweeper links are read-only.
 */
export function opsItemIsActionable(item: OpsItem): boolean {
  return (
    item.kind === 'override' ||
    item.kind === 'confirmation' ||
    item.kind === 'topup-extension' ||
    item.kind === 'unpaid-artist' ||
    item.kind === 'no-rebook' ||
    item.kind === 'came-down' ||
    item.kind === 'payby-extension' ||
    (item.kind === 'unclosed-link' && !item.readOnly)
  );
}
